import ViewField from "components/ViewField";
import ModalSkeleton from "modals/ModalSkeleton";
import classes from "./ViewFormsModal.module.css";

export default function ViewFormsModal({ show, setShow, data }) {
  return (
    <ModalSkeleton
      show={show}
      setShow={setShow}
      header={"View Forms"}
      width={"600px"}
      showCloseIcon={true}
    >
      <div className={classes.container}>
        <ViewField label={"Name"} value={data?.fullName || ""} />
        <ViewField label={"Email"} value={data?.email || ""} />
        <ViewField
          label={"Message"}
          value={data?.message || ""}
          type="textarea"
        />
      </div>
    </ModalSkeleton>
  );
}
